const OptionCard = ({
  option,
  isCorrect,
}: {
  option: any;
  isCorrect: boolean;
}) => (
  <div
    className={`min-w-[150px] px-4 py-2 rounded-md border ${
      isCorrect ? "border-green-500 bg-green-50" : "border-gray-300"
    }`}
  >
    <p className="text-sm text-gray-700">{option.text}</p>
  </div>
);

export default OptionCard;
